import { Action, createReducer, on } from '@ngrx/store';
import * as resendInviteActions from '../actions/resend-invite.actions';

export const resendInviteFeatureKey = 'resendInvite';

export interface ResendInviteState {
  loadResendInvite: any;
  loadResendInviteResponse: any;
  loadResendInviteFailure: any;
}

export const initialState: ResendInviteState = {
  loadResendInvite: undefined,
  loadResendInviteResponse: undefined,
  loadResendInviteFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(resendInviteActions.loadResendInvitesSuccess, (state, action) => ({
    ...state,
    loadResendInvite: action.response
  })),
  on(resendInviteActions.loadResendInvitesFailure, (state, action) => ({
    ...state,
    loadResendInvite: action.error
  }))
);
